exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prop-editor .pattern-input .form-value{width:100%}.prop-editor .simple-tbl>.head>.row>td{background-color:#f5f5f5}.prop-editor .simple-tbl>.body>tr.row>td.label{background-color:#eee}.prop-editor.no-grid .simple-tbl>.head>.row>td{background-color:transparent}.prop-editor.no-grid .simple-tbl>.body>tr.row>td{border:1px solid transparent}.prop-editor.no-grid .simple-tbl>.body>tr.row>td.label{background-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59d8902f","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/ctrl/PropEditor.vue
// module id = 1659
// module chunks = 1